import Button from 'tio-ui/components/button';
import { t } from 'ember-intl';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import { HStack, Section, VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import { PhCheck } from 'ember-phosphor-icons';

<template>
  <PageHeader @title={{t "syf.insights.idr.heading"}} @sticky={{false}}>
    <:breadcrumbs as |b|>
      <b.crumb @route="authenticated.syf.dashboard" @label="Dashboard" />
      <b.crumb @label="IDR" />
    </:breadcrumbs>
  </PageHeader>
  <Section>
    <:body>
      <HStack>
        <VStack class="w-full md:w-1/2">
          <h2 class="tio-text-lg-semibold">{{t "syf.insights.idr.explore.heading"}}</h2>
          <p>{{t "syf.insights.idr.explore.one"}}</p>
          <p>{{t "syf.insights.idr.explore.two"}}</p>
        </VStack>
        <VStack class="w-full md:w-1/2">
          <h2 class="tio-text-lg-semibold">{{t "syf.insights.idr.advantage.heading"}}</h2>
          <div class="tio-row-top-tight">
            <PhCheck @size="24" class="tio-fg-success" />
            <p>{{t "syf.insights.idr.advantage.one"}}</p>
          </div>
          <div class="tio-row-top-tight">
            <PhCheck @size="24" class="tio-fg-success" />
            <p>{{t "syf.insights.idr.advantage.two"}}</p>
          </div>
          <div class="tio-row-top-tight text-base leading-6">
            <PhCheck @size="16" class="tio-fg-success flex-none" />
            <p>{{t "syf.insights.idr.advantage.three"}}</p>
          </div>
          <hr />
          <div>{{t "syf.insights.idr.advantage.label"}}</div>
          <Button
            @intent="primary"
            @appearance="outlined"
            {{on "click" (transitionTo "authenticated.idr")}}
          >
            {{t "syf.insights.idr.advantage.button"}}
          </Button>
        </VStack>
      </HStack>
    </:body>
  </Section>
</template>
